import GalleryWidget from '../../../editor/features/build/requestModels/widgets/GalleryWidget';
import { useCommonWidgetHandlers } from './use-common-widget-handlers';

export const useGalleryWidgetHandlers = () => {
  const commonWidgetHandlers = useCommonWidgetHandlers();

  const addNew = async (dialogueId: number, sortOrder: number) => {
    const newWidget = GalleryWidget.make(dialogueId, sortOrder);

    return commonWidgetHandlers.create(newWidget, dialogueId, sortOrder);
  };

  return {
    delete: commonWidgetHandlers.delete,
    addNew,
  };
};
